var OCS = OCS || {};

OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};

var env = (OCS.ENVIRONMENT === 'PRODUCTION') ? 'prod' : (OCS.ENVIRONMENT === 'STAGING') ? 'test' : 'dev';
var url_prefix = (OCS.ENVIRONMENT === 'PRODUCTION') ? '' : (OCS.ENVIRONMENT === 'STAGING') ? 'x' : 'x';
var tld = (OCS.ENVIRONMENT === 'DEVELOPMENT') ? 'local' : 'org';


OCS.WxBriefing.Functions.define_ui_class = function () {
    return new Class({
        Implements: [Options, Events],
        active: false,
        bound_methods: {},
        manager_name: 'UI',
        options: {
            debug: false,
            escape_key_code: 27,
            event_namespace: '.ui_event',
            states: {
                overlay_open: false,
                prefences_menu_open: false,
                load_default_panel_config: false
            },
            cleanup_interval: 1 * 15 * 60 * 1000, // 15 minutes
            shake_hands_interval: 3 * 60 * 1000, // 3 minutes
            data_manager_ops: {
                manager_name: 'data_manager',
                polygon_amp_prefix: "poly_",
                webworker_radar_parser: true,
                data_worker_ops: {
                    actively_retrieve_data: true,
                }
            },
            adv_manager_ops: {
                advisory_container: '',
                advisory_max_width: 250,
                channel_name: [],
                dataset: 'edu.ou.ocs.advisories',
                data_manager_selector: document.body,
                geom_manager_selector: document.body,
                draw_type_lat_lon: 'lat_lon',
                map_selector: '.map',
                request_ops_layer_name: 'advisory_manager',
                subscribe_to_all: false,
                filtered_wfo_offices: []
            },
            handshake_location: "/index.php/api/weather_briefing/handshake",
            fetch_site_info_location: "https://pcb.mesonet.org/find/siteinfo-json",
            update_panel_config_location: '/index.php/api/weather_briefing/update_panel_config/format/json',
            panelconfig_api_location: "/index.php/api/weather_briefing/panelconfig/method/{method}/panelconfig_id/{panelconfig_id}/format/json",
            site_select_results_location: '/index.php/site/site_select_results_json/',
            nws_stations_config_location: "/config/stations.json",
            popup_container_id: 'popup_obj_container',
            popup_container_data_name: 'popup_form',
            update_url_event_string: 'update_url_event',
            ga_category: 'desktop',
            send_ga_event: true,
            ui_mask_id: 'ui_mask',
            preloaded_templates: [
                'myproducts_menu', 'alert_window', 'panel_contents', 'panel_options_base', 'about_window_template', 'preferences_menu',
                'panel_config_chooser', 'image_embed', 'text_embed', 'object_embed',
                'category_preview', 'product_preview', 'search_results'
            ],
            url_template_replace_strings: ['home_county', 'home_stid', 'ww_counties', 'radar']
        },
        mask: null,
        events: {},
        popup_container: null,
        cleanup_interval: null,
        shake_hands_interval: null,
        initialize: function (op) {
            OCS.console.debug_text('OCS.UI initialized');
            this.setOptions(op);
            OCS.Functions.get_ajax_manager({storeCompletedReq: 0});
            this.bound_methods.on_popup_close = this.on_popup_close.bind(this);
            this.bound_methods.handle_change_platform_btn_click = this.handle_change_platform_btn_click.bind(this);
            this.bound_methods.handle_log_out_btn = this.handle_log_out_btn.bind(this);

        },
        start: function () {
            this.send_analytic_event({'category': 'Status', 'action': 'Login'});
            this.active = true;
            this.init_events();
            this.init_ajax();
            this.init_templates();
            this.init_handshake();
            this.init_cleanup();
            this.init_buttons();
            OCS.WxBriefing.Functions.get_search_manager().start();
            OCS.WxBriefing.Functions.get_ui_menu().fetch_menu();
            OCS.WxBriefing.Functions.get_ui_menu().get_myproducts_menu().build_myproducts();
            OCS.WxBriefing.Functions.get_panel_manager().start();
            OCS.WxBriefing.Functions.get_notice_manager();
            this.get_popup_obj();
        },
        /*
         * Initialization and corresponding uninitialization methods
         */
        init_events: function () {
            this.addEvent('new_data_arrival', this.handle_new_data_arrival.bind(this));
            this.addEvent('ping_recieved', this.handle_ping.bind(this));
            this.addEvent('send_ga_event', this.handle_send_ga_event.bind(this));
            document.id(window).addEvent('keydown', this.handle_keydown.bind(this));
            var em = OCS.WxBriefing.Functions.get_event_manager();

            if (this.events.new_data_arrival) {
                em.unsubscribe(this.events.new_data_arrival);
            }
            this.events.new_data_arrival = em.subscribe({'event_name': "new_data_arrival", 'callback': this.handle_new_data_arrival.bind(this)});


            if (this.events.ping_recieved) {
                em.unsubscribe(this.events.ping_recieved);
            }
            this.events.ping_recieved = em.subscribe({'event_name': "ping_recieved", 'callback': this.handle_ping.bind(this)});


            if (this.events.send_ga_event) {
                em.unsubscribe(this.events.send_ga_event);
            }
            this.events.send_ga_event = em.subscribe({'event_name': "send_ga_event", 'callback': this.handle_send_ga_event.bind(this)});


        },
        remove_events: function () {
            document.body.getElements('header .settings_menu .change_platform_btn').removeEvent('click', this.bound_methods.handle_change_platform_btn_click);
            document.body.getElements('header .settings_menu .logout_btn').removeEvent('click', this.bound_methods.handle_log_out_btn);
            this.removeEvents();
            var em = OCS.WxBriefing.Functions.get_event_manager();
            Object.each(this.events, function (event_key) {
                em.unsubscribe(event_key);
            }.bind(this));
            this.events = {};
        },
        init_buttons: function () {
            OCS.WxBriefing.Functions.get_preferences_manager();
            this.init_change_playform_button();
            this.init_logout_button();
        },
        init_change_playform_button: function () {
            document.body.getElements('header .settings_menu .change_platform_btn').addEvent('click', this.bound_methods.handle_change_platform_btn_click);
        },
        init_logout_button: function () {
            document.body.getElements('header .settings_menu .logout_btn').addEvent('click', this.bound_methods.handle_log_out_btn);
        },
        init_cleanup: function () {
            if (!this.cleanup_interval) {
                this.cleanup_interval = setInterval(this.on_cleanup.bind(this), this.options.cleanup_interval);
            }
        },
        stop_cleanup: function () {
            if (this.cleanup_interval) {
                clearInterval(this.cleanup_interval);
            }
        },
        init_handshake: function () {
            if (!this.shake_hands_interval) {
                this.shake_hands_interval = setInterval(this.on_handshake.bind(this), this.options.shake_hands_interval); // every 3 minutes
            }
        },
        stop_handshake: function () {
            if (this.shake_hands_interval) {
                clearInterval(this.shake_hands_interval);
            }
        },
        init_ajax: function () {
            var req;
            var am = OCS.Functions.get_ajax_manager();
            req = am.request("shake_hands", {
                url: this.options.handshake_location,
                dataType: "json",
                corsRequest: false,
                noCache: true,
                headers: {'X-Network-Only': 'true'},
                method: "GET"
            });
            req.addEvent('success', function () {
                this.send_analytic_event({'category': 'Status', 'action': "Alive", 'nonInteraction': true});
            }.bind(this));

            req = am.request("fetch_site_info", {
                url: this.options.fetch_site_info_location,
                dataType: "json",
                corsRequest: false,
                method: "GET"
            });
            req.addEvent('success', function (data) {
                OCS.Constants.SITES = data.json;
            }.bind(this));
            req.send();
            req = am.request("nws_stations", {
                url: this.options.nws_stations_config_location,
                dataType: "json",
                corsRequest: false,
                method: "GET"
            });
            req.addEvent('success', function (data) {
                OCS.Constants.NWS_STATIONS = data.json;
            }.bind(this));
            req.send();

        },
        destroy_ajax: function () {
            var am = OCS.Functions.get_ajax_manager();
            am.remove_request('shake_hands');
            am.remove_request('fetch_site_info');
            am.remove_request('nws_stations');
        },
        init_templates: function () {
            var tm = OCS.WxBriefing.Functions.get_template_manager();
            this.options.preloaded_templates.each(function (template) {
                tm.define_template(template, $('#' + template).html());
            }.bind(this));
        },

        /*
         * Event fires
         */


        /*
         * Event Listeners
         */
        on_popup_close: function (event, popup) {
            // If we have a map tied to the popup, make sure it gets destroyed.
            if (popup.mymap) {
                popup.mymap.destroy();
                delete popup.mymap;
            }
            // Map has been removed, don't need the event now
            popup.removeEvent('close', this.bound_methods.on_popup_close);
        },

        /* 
         * Other UI related methods
         */

        handle_change_platform_btn_click: function (e) {
            e.stop();
            var contrl = OCS.WxBriefing.Functions.get_wx_briefing_controller();
            if (OCS.device.desktop) {
                setTimeout(function () {
                    contrl.switch_platform('mobile');
                }, 100);
                return;
            }
            if (OCS.device.mobile || OCS.device.tablet) {
                setTimeout(function () {
                    contrl.switch_platform();
                }, 100);
                return;
            }
        },
        handle_keydown: function (e) {
            if (e.code === this.options.escape_key_code) {
                this.reset_ui();
            }
        },
        handle_new_data_arrival: function (e) {
            //this.send_analytic_event({'category': 'Data', 'action': "New"}, true);
        },
        handle_ping: function (e, value) {
            this.send_analytic_event({'category': 'Ping', 'action': value.action, 'label': value.value}, true);
        },
        handle_send_ga_event: function (e, event) {
            this.send_analytic_event(event);
        },
        on_cleanup: function () {
            OCS.console.debug_text("UI: cleanup activated");
            OCS.WxBriefing.Functions.get_event_manager().publish('cleanup');
        },
        on_handshake: function () {
            var req = OCS.Functions.get_ajax_manager().request("shake_hands");
            if (req) {
                req.send();
            }

        },
        show_product_fullscreen: function (product, options) {
            var popup = this.get_popup_obj();
            var map_popup_panel = OCS.WxBriefing.Functions.get_panel_manager().create_panel('map_popup', {'append_to_container': false, 'popup': popup});
            popup.set_popup_data(map_popup_panel.get_panel());
            popup.open_form(); // This needs to happen first so that the relevant DOM-IDs are accessible when adding the product
            map_popup_panel.set_popup(popup);
            map_popup_panel.add_product_to_panel(product);
            if(options) {
                map_popup_panel.set_product_meta_info(options);
            }

        },
        replace_url_template_text: function (text) {
            this.options.url_template_replace_strings.each(function (key) {
                text = text.split('{{' + key + '}}').join(OCS.User.get_user_preference(key));
            });

            var now = moment(),
                    day_of_year;
            if (!now.isLeapYear() && now.isAfter('2/28/' + now.year())) {
                now.add('d', 1);
            }
            day_of_year = now.format('DDDD');
            text = text.split('{{day_of_year}}').join(day_of_year);

            return text;
        },
        // Site search related
        fetch_site_search_results: function (search_term, callback) {
            var am = OCS.Functions.get_ajax_manager();
            search_term = String(search_term).trim();
            var req = am.request('fetch_sites');
            if (req) {
                if (callback) {
                    req.then(callback);
                }
                req.send({data: {zip: search_term}});
            }
        },
        show_site_search_results: function (data, callback, context) {
            var container = $('#site_search_results_container');
            container.empty();
            // loop throgh data
            Object.each(data, function (item) {
                container.append('<li class="category"><a href="" data-stid="' + item.stid + '" data-name="' + item.name + '">' + item.name + '</a></li>');
            });

            var content = container.children();

            var ss = document.id('site_search').getCoordinates(document.body);
            var top = ss.bottom;
            var left = ss.right - 250;

            var max_menu_height = Math.floor($('.popup_content_container').outerHeight() * 0.9);
            container.css({
                'position': 'absolute',
                'top': top + "px",
                'left': left + "px",
                'max-height': max_menu_height + 'px',
                'overflow': 'auto',
                'height': 'auto',
                'z-index': 3100,
                'background': '#fff',
                'width': '250px',
                'padding-left': '0px',
                'margin-top': '0px'
            });

            container.html(content).show().find('.vertical_menu').show();
            container.find('a').off().on('click', function (e) {
                e.preventDefault();
                var data = $(e.currentTarget).data();
                callback(data, context);
            });
        },
        /* 
         * Loading related methods 
         */

        load_county_selector: function (title, callback, county_limit) {
            var counties_to_use = [];
            title = title || 'Select Mesonet Site';
            callback = callback || null;
            var context = context || null;
            county_limit = county_limit || 1;
            var popup = this.get_popup_obj('county_selector_popup');
            var map_popup_panel = OCS.WxBriefing.Functions.get_panel_manager().create_panel('county_selector_popup', {'append_to_container': false, 'popup': popup, 'class_name': 'panel full_height'});
            popup.set_popup_data(map_popup_panel.get_panel());
            popup.open_form(); // This needs to happen first so that the relevant DOM-IDs are accessible when adding the product
            map_popup_panel.set_popup(popup);

            popup.set_title(title);
            if (county_limit > 1) {
                var ww_counties_arr = OCS.User.get_user_preference('ww_counties').split(',');
                counties_to_use = ww_counties_arr;
            } else {
                var county = OCS.User.get_user_preference('home_county');
                if (county) {
                    counties_to_use.push(county.toUpperCase());
                }
            }

            var mymap = new OCS.Viewer.Classes.MapManager(map_popup_panel.panel, {
                center: [-97.3, 35.3],
                numZoomLevels: 9,
                defaultZoom: 7,
                minZoom: 6,
                extent: new OCS.Viewer.Classes.MapManager().get_state_map_bounds()
            });
            mymap.zoom_to_oklahoma();

            if (!counties_to_use || !counties_to_use.length) {
                counties_to_use = [];
            }
            mymap.add_county_selector(counties_to_use, county_limit, callback);
            popup.mymap = mymap;
            popup.addEvent('close', this.bound_methods.on_popup_close);
        },
        load_site_selector: function (title, callback, context) {
            var popup = this.get_popup_obj('site_selector_popup');
            var map_popup_panel = OCS.WxBriefing.Functions.get_panel_manager().create_panel('site_selector_popup', {'append_to_container': false, 'popup': popup, 'class_name': 'panel full_height'});
            popup.set_popup_data(map_popup_panel.get_panel());
            popup.open_form(); // This needs to happen first so that the relevant DOM-IDs are accessible when adding the product
            map_popup_panel.set_popup(popup);
            popup.set_title(title +
                    '<input id="site_search" type="text" name="site_search" value="" placeholder="Type a City Name or Zip Code" />' +
                    '<ul id="site_search_results_container" class="submenu vertical_menu"></ul><div class="clearfix"></div>'
                    );

            callback = callback || null;
            context = context || null;

            var mymap = new OCS.Viewer.Classes.MapManager(map_popup_panel.panel, {
                center: [-97.3, 35.3],
                numZoomLevels: 9,
                defaultZoom: 7,
                minZoom: 6,
                extent: new OCS.Viewer.Classes.MapManager().get_state_map_bounds()
            });
            mymap.zoom_to_oklahoma();
            mymap.add_default_layers();
            mymap.add_zoom_interaction();

            var stid_to_use = $(context).closest('svg').attr('current_stid') || OCS.User.get_user_preference('home_stid');
            mymap.add_mesonet_site_selector(stid_to_use.toLowerCase(), callback);

            // Setup the site search
            var am = OCS.Functions.get_ajax_manager();
            var req = am.request("fetch_sites", {
                url: this.options.site_select_results_location,
                dataType: "json",
                method: "GET"
            });
            req.addEvent('success', function (data) {
                this.show_site_search_results(data.json, callback, context);
            }.bind(this));
            var fetch = OCS.Utilities.create_debounced_method(this.fetch_site_search_results.bind(this), 500);
            var site_search_el = document.id('site_search');
            if(site_search_el) {
                site_search_el.addEvent('keyup', function (event) {
                    var search_term = event.target.get('value');
                    if (search_term.length > 2) {
                        fetch(search_term, callback);
                    }
                });
            }

            popup.mymap = mymap;
            popup.addEvent('close', this.bound_methods.on_popup_close);
        },
        load_radar_selector: function (title, callback, context) {
            title = title || 'Select Default Radar Location';
            callback = callback || null;
            context = context || null;
            var popup = this.get_popup_obj('radar_selector_popup');
            var map_popup_panel = OCS.WxBriefing.Functions.get_panel_manager().create_panel('radar_selector_popup', {'append_to_container': false, 'popup': popup, 'class_name': 'panel full_height'});
            popup.set_popup_data(map_popup_panel.get_panel());
            popup.open_form(); // This needs to happen first so that the relevant DOM-IDs are accessible when adding the product
            map_popup_panel.set_popup(popup);
            popup.set_title(title);
            var mymap = new OCS.Viewer.Classes.MapManager(map_popup_panel.panel, {
                center: [-97.3, 35.3],
                numZoomLevels: 9,
                defaultZoom: 7,
                minZoom: 6,
                extent: new OCS.Viewer.Classes.MapManager().get_state_map_bounds()
            });
            mymap.zoom_to_oklahoma();
            mymap.add_default_layers();
            //mymap.add_zoom_interaction();
            mymap.add_radar_selector(OCS.User.get_user_preference('radar'), callback);

            popup.mymap = mymap;
            popup.addEvent('close', this.bound_methods.on_popup_close);
        },
        start_overlay_spinner: function () {
            var mask = this.get_mask();
            mask.showMask();
            document.id(this.options.ui_mask_id).addClass('spinner').addClass('large');
        },
        /* 
         * Get and set methods 
         */
        get_debug: function () {
            return this.options.debug;
        },
        set_debug: function (val) {
            this.options.debug = val;
            if (val) {
                document.body.addClass('debug');
            } else {
                document.body.removeClass('debug');
            }
            this.options.data_manager_ops.debug = val;
            this.options.adv_manager_ops.debug = val;
            var menu = OCS.WxBriefing.Functions.get_ui_menu();
            menu.set_debug(val);
        },
        set_actively_retrieve_data: function (val) {
            this.options.data_manager_ops.data_worker_ops.actively_retrieve_data = val;
        },
        get_panel_config: function (name) {
            return OCS.WxBriefing.Functions.get_panel_manager().get_panel_config(name);
        },
        get_popup_obj: function (container_data_name, ops) {
            var popup_ops;
            if (!container_data_name) {
                container_data_name = this.options.popup_container_data_name;
            }
            if (!this.popup_container) {
                var container = document.id(this.options.popup_container_id);
                if (container) {
                    this.popup_container = container;
                } else {
                    this.popup_container = new Element('div', {
                        "id": this.options.popup_container_id
                    }).inject(document.body);
                }
            }
            var popup_class = this.get_popup_obj_class();
            var base_popup_ops = {'storage_name': container_data_name};
            if (ops) {
                popup_ops = OCS.Utilities.combine_objects(base_popup_ops, ops);
            } else {
                popup_ops = base_popup_ops;
            }
            var popup = new popup_class(this.popup_container, popup_ops);
            return popup;
        },
        get_popup_obj_class: function () {
            return OCS.WxBriefing.Classes.PanelPopup;
        },
        get_mask: function () {
            if (!this.mask) {
                this.mask = new Mask(document.id('page_container'), {id: this.options.ui_mask_id});
            }
            return this.mask;
        },
        // log user out
        handle_log_out_btn: function (e) {
            e.stop();
            var r = confirm("Are you sure you would like to sign out?");
            if (r === true) {
                this.stop(function () {
                    this.send_analytic_event({'category': 'Status', 'action': 'Logout'});
                    window.location = '/index.php/okfirst/logout';
                }.bind(this));

            }
        },
        /* 
         * Stop, and reset methods
         */
        reset_ui: function () {
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
        },
        set_send_ga_event: function (val) {
            this.options.send_ga_event = val;
        },
        send_analytic_event: function (event, nonInteractive) {
            var pm = OCS.WxBriefing.Functions.get_product_manager();
            var event_data = {'hitType': 'event'};
            if (event.hasOwnProperty('nonInteraction')) {
                event_data.nonInteraction = true;
            }
            if (event.hasOwnProperty('category')) {
                event_data.eventCategory = event.category + ' - ' + this.options.ga_category;
            }
            if (event.hasOwnProperty('entry_id')) {
                event_data.eventLabel = pm.get_product_ga_label(event.entry_id);
            }
            if (event.hasOwnProperty('label')) {
                event_data.eventLabel = event.label;
            }
            if (event.hasOwnProperty('action')) {
                event_data.eventAction = event.action;
            }
            if (event.hasOwnProperty('value')) {
                event_data.eventValue = event.value;
            }
            OCS.console.debug_text('Google Analytics Event: ', event_data);


            if (typeof (gtag) !== 'undefined' && gtag && this.options.send_ga_event) {
                gtag('event', event.action, event_data);
            }
        },
        stop: function (callback) {
            this.reset_ui();
            if (this.active) {
                this.start_overlay_spinner();
                this.stop_handshake();
                this.stop_cleanup();
                OCS.WxBriefing.Functions.get_ui_menu().destroy();
                OCS.WxBriefing.Functions.get_notice_manager().destroy();
                OCS.WxBriefing.Functions.get_panel_manager().destroy();
                OCS.WxBriefing.Functions.get_search_manager().destroy();
                var em = OCS.WxBriefing.Functions.get_event_manager();
                em.publish("destroy");
                this.active = false;
                $('#' + this.options.ui_mask_id).removeClass('spinner');
                var mask = this.get_mask();
                mask.hideMask();
                this.mask = null;
                if (callback) {
                    callback();
                }
            }
        },
        destroy: function () {
            this.stop();
            this.remove_events();
            this.destroy_ajax();
            this.removeEvents();
        }
    }); // End OCS.WxBriefing.Classes.UI
};
